//import { RichTextInput, DefaultEditorOptions } from "ra-input-rich-text";
import * as React from "react";
import { Pagination, List, Datagrid, TextField, NumberInput, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';

import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "../styles/common.js";
import Stack from '@mui/material/Stack';


export const WebsiteContentCategoryList = props => (
    <List exporter={false} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des catégories de contenu" />
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="name" label="Nom" />
        </Datagrid>
    </List>
);

export const WebsiteContentCategoryEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Édition d'une catégorie de contenu" />
        <SimpleForm>
            <Stack direction="column" spacing={10} style={commonStyles.stackColumn}>
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} disabled source="id" label="Id" />
                
                <TextInput style={{...commonStyles.inputStyle, margin: "auto"}} source="name" label="Nom"/>
            </Stack>
        </SimpleForm>
    </Edit>
);
